export default "__VITE_ASSET__CQph3HQH__"